module.exports = __webpack_public_path__ + "static/business-520f98405022a3e4d74596a35c1516bf.jpg";